<template>
  <div class="flex items-center gap-4">
    <div class="social-icon" :class="{ border, compact }">
      <img :src="src" alt="" srcset="" class="" />
    </div>
    <span v-if="showLabel" class="small medium">{{ label }}</span>
  </div>
</template>

<script lang="ts">
  import { useConfsStore } from '@/store/confs';
  import { mapStores } from 'pinia';

  export default {
    name: 'WSocialIcon',
    props: {
      value: { type: String, required: true },
      border: { type: Boolean, default: true },
      showLabel: { type: Boolean, default: false },
      compact: { type: Boolean, default: false },
    },
    methods: {},
    computed: {
      ...mapStores(useConfsStore),
      src() {
        return this.confsStore.getChannelSrcFromValue(this.value);
      },
      label() {
        return this.confsStore.conf.channels.find((e: any) => e.value === this.value)?.label;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables';
  .social-icon {
    height: 2rem;
    aspect-ratio: 1;
    border-radius: 50%;
    padding: 0.25rem;

    img {
      object-fit: cover;
    }
  }
  .border {
    border: none;
    outline: 1px solid $input-border;
  }
  .compact {
    padding: 0;
    height: 1.25rem;
  }
</style>
